module.exports = __webpack_public_path__ + "static/gallery_peak_1-c8843a34e51fc574db05792efce47fa9.jpg";